import { QueryKey, UseQueryOptions } from 'react-query';
import { titleSettings } from '../../../config';
import { FetchAssetOptions, fetchTitle, FetchTitleOptions, getAsset } from './api';
import { assetKey, titleKey } from './keys';
import { Asset } from './types/asset';

export interface TitleQueryOptions extends FetchTitleOptions {
  id: string;
  enabled?: boolean;
}

export function titleQuery({ id, enabled, ...options }: TitleQueryOptions) {
  return {
    queryKey: titleKey(id, options),
    queryFn: () => fetchTitle(id, options),
    enabled: enabled,
    staleTime: titleSettings.staleTime,
    cacheTime: titleSettings.cacheTime,
    retry: false,
  } as const;
}

export interface AssetQueryOptions<T = Asset> extends FetchAssetOptions, UseQueryOptions<Asset, unknown, T, QueryKey> {
  id: string;
  enabled?: boolean;
}

/**
 * Use the omit options to unsubscribe from invalidations to the query.
 */
export function assetQuery({ id, enabled, orderByProviderId, orderByServiceType, ...options }: AssetQueryOptions) {
  return {
    queryKey: assetKey(id, { orderByProviderId, orderByServiceType }),
    queryFn: () => getAsset(id, { orderByProviderId, orderByServiceType }),
    enabled: enabled,
    ...options,
  } as const;
}
